import { ComponentProps } from 'react';

const BordAddIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_23933_5141)">
        <path
          d="M0.685061 7.33474C0.795156 8.36381 1.6228 9.19145 2.65134 9.3061C4.23119 9.48217 5.76769 9.48217 7.34751 9.3061C8.37609 9.19145 9.20373 8.36381 9.3138 7.33474C9.39509 6.57509 9.46373 5.79519 9.46373 5.00007C9.46373 4.20497 9.39509 3.42507 9.3138 2.66542C9.20373 1.63638 8.37609 0.808732 7.34751 0.694085C5.76769 0.517987 4.23119 0.517987 2.65134 0.694085C1.6228 0.808732 0.795156 1.63638 0.685061 2.66542C0.603787 3.42507 0.535156 4.20497 0.535156 5.00007C0.535156 5.79519 0.603788 6.57509 0.685061 7.33474Z"
          fill="#070F21"
          stroke="white"
        />
        <path d="M5.00056 3.21436V6.78578M6.78627 5.00007H3.21484" stroke="white" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_23933_5141">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordAddIcon;
